import { useSearchParams } from "react-router-dom";

export function useReadParamsFromUrl<T>(
  getFieldsFromUrl: (params: URLSearchParams) => T
) {
  const [params] = useSearchParams();

  return getFieldsFromUrl(params);
}
